<div [ngStyle]="{'max-width': sideNavOpenStatus ? 'calc(100vw - 535px)' : 'calc(100vw - 415px)'}"
      fxLayout="row">
  <mat-tab-group #tabGroup class="nav-page-tab-navigator" [(selectedIndex)]="selectedTab"
                 (selectedTabChange)="onTabChange($event)"
                 animationDuration="0ms" [disableRipple]="true">

    <mat-tab *ngFor="let page of pages; let i = index">
      <ng-template mat-tab-label>
        <div [ngClass]="selectedTab === i ? 'tab-label-active' : 'tab-label'" fxLayout="row"
             fxLayoutAlign="space-between center"
             [cdkContextMenuTriggerFor]="pages.length > 1 ? nav_context_menu:null">
          <div fxLayout="column" fxLayoutAlign="center start">
            <span class="tab-label-page truncate-text">{{page.name}}</span>
            <span class="tab-label-heading truncate-text">{{page.heading}}</span>
          </div>
          <button mat-icon-button class="tab-label-button" (click)="closeTab(page)">
            <mat-icon>cancel</mat-icon>
          </button>
        </div>
      </ng-template>
    </mat-tab>

    <mat-tab *ngIf="pages.length > 2">
      <ng-template mat-tab-label>
        <mat-label class="tab-navbar-close-all" (click)="closeAllTabs()">Close all</mat-label>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>

<ng-template #nav_context_menu>
  <mat-list class="tab-navigator-tab-menu" cdkMenu>
    <button mat-list-item cdkMenuItem class="tab-navigator-tab-menu-item" (click)="closeAllTabs()">Close All</button>
    <button mat-list-item cdkMenuItem class="tab-navigator-tab-menu-item" (click)="closeOthers()">Close Others</button>
  </mat-list>
</ng-template>
